import {createSelector} from "reselect";
import {IStore} from "modules/types/store";
import {RequestState} from "modules/enums";
import {parseRequestStateType} from "modules/utils";

export const getAchievementsState = (store: IStore) => store.userAchievements;

export const getUserAchievements = createSelector(
	getAchievementsState,
	({achievements}) => achievements
);

export const getUserEarnedAchievements = createSelector(getUserAchievements, (achievements) =>
	achievements.filter((achievement) => achievement.earned)
);

export const getUserAchievementsIsLoading = createSelector(
	getAchievementsState,
	({requestState}) => requestState === RequestState.Requested
);

export const getUserAchievementsRequestStates = createSelector(
	getAchievementsState,
	({requestState}) => parseRequestStateType(requestState)
);

export const getUserGameAchievements = createSelector(
	getAchievementsState,
	({achievements}) =>
		(game: string) =>
			achievements.filter((achievement) => achievement.game === game)
);

export const getUserAchievementsByName = createSelector(
	getAchievementsState,
	({achievements}) =>
		(name: string) =>
			achievements.find((achievement) => achievement.name === name)
);

export const getAchievementsGames = createSelector(getUserAchievements, (achievements) => [
	...new Set(achievements.map(({game}) => game)),
]);
